import { formatBytes } from "../../../utils/formatBytes";
import type { UseExportPresentationPreviewResult } from "../../../hooks/useExportPresentationPreview";
import type { PresentationDownloadFormatApi } from "../../../services/storyPresentation/storyPresentation.types";
import type { DeliveryAttachmentPreview } from "./types";

const FILE_TYPE_NAME: Record<PresentationDownloadFormatApi, string> = {
  pptx: "PowerPoint (.pptx)",
  pdf: "PDF (.pdf)",
};

/**
 * The rendered deck as the preview card shows it: its front page, what kind
 * of file it is, and how big — the same file the delivery attaches.
 */
export const toAttachmentPreview = (
  format: PresentationDownloadFormatApi,
  preview: Pick<
    UseExportPresentationPreviewResult,
    "pageUrls" | "fileSizeBytes" | "isRendering" | "errorMessage"
  >,
): DeliveryAttachmentPreview => ({
  status: preview.isRendering ? "rendering" : preview.errorMessage ? "error" : "ready",
  imageUrl: preview.pageUrls[0],
  name: FILE_TYPE_NAME[format],
  sizeLabel: preview.fileSizeBytes == null ? null : formatBytes(preview.fileSizeBytes),
  errorMessage: preview.errorMessage,
});
